import React, { forwardRef, memo } from 'react';

interface KawaiiTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

// Use forwardRef to get the ref argument!
export const KawaiiTextAreaComponent = forwardRef<HTMLTextAreaElement, KawaiiTextAreaProps>(
  ({ label, error, className = '', ...props }, ref) => {
    // Destructure props inside the function body
    return (
      <div className="space-y-1">
        {label && (
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            {label}
          </label>
        )}
        <div className="relative group">
          <textarea
            // Pass the ref directly to the textarea! Magic! ✨
            ref={ref}
            className={`
            w-full px-4 py-2 rounded-2xl
            border-2 border-pink-200 dark:border-pink-700
            bg-white dark:bg-gray-900
            text-gray-700 dark:text-gray-300
            placeholder:text-gray-400 dark:placeholder:text-gray-600
            transition-all duration-200
            focus:outline-hidden focus:border-pink-400 dark:focus:border-pink-500
            focus:ring-2 focus:ring-pink-400/50 dark:focus:ring-pink-500/50
            focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900
            resize-none
            ${error ? 'border-red-500 focus:border-red-500' : ''}
            ${className}
          `}
            {...props} // Spread the rest of the props here
          />
        </div>
        {error && <p className="text-sm text-red-500">{error}</p>}
      </div>
    );
  },
);

// Optional, but good for debugging!
KawaiiTextAreaComponent.displayName = 'KawaiiTextArea';

export const KawaiiTextArea = memo(KawaiiTextAreaComponent);
